import React, { Component } from 'react';
import Style from './FullWidthImg.css';

class FullWidthImg extends Component{
	render(){
		return(
			<div style={Style.FullWidthImg} className={`full-bg-img ${this.props.bgID}`}></div>
		)
	}
};

export default FullWidthImg;